module.exports = __webpack_public_path__ + "img/ca.46482a1e.svg";